import { useState, useEffect } from 'react';
import useSWR from 'swr';

import { FOCUS_THROTTLE_INTERVAL } from '@/config/appSettings';

import { IResponseError } from '@/lib/apiBase';
import { IReferralStatus, fetchReferralStatus } from '@/lib/namespaceApi';

const REFRESH_INTERVAL = 30 * 1000; // 30 seconds

const useReferralStatus = (namespace: string, initialData?: IReferralStatus) => {
  const [referralStatus, setReferralStatus] = useState<IReferralStatus | undefined>(initialData);
  const [error, setError] = useState<IResponseError | undefined>();

  const fetchKey = `referral-status-${namespace}`;
  const {
    data,
    error: requestError,
    isValidating,
  } = useSWR(fetchKey, () => fetchReferralStatus({ namespace }), {
    keepPreviousData: true,
    focusThrottleInterval: FOCUS_THROTTLE_INTERVAL,
    refreshInterval: REFRESH_INTERVAL,
    fallbackData: initialData,
  });

  useEffect(() => {
    if (data) {
      setReferralStatus(data);
      setError(requestError as IResponseError);
    }
  }, [data, requestError]);

  const loading: boolean = isValidating && !referralStatus;

  return {
    loading,
    referralStatus,
    error,
  };
};

export default useReferralStatus;
